import React, { useEffect, useState } from 'react';
import { Stack, Text } from '@moda/om';
import { CheckoutNotification } from './CheckoutNotification';

interface Props {
  priceChangedMessage: string | null;
}

export const PriceChangeNotification: React.FC<Props> = ({ priceChangedMessage }) => {
  const [showNotification, setShowNotification] = useState<boolean>(true);
  useEffect(() => {
    if (priceChangedMessage) setShowNotification(true);
  }, [priceChangedMessage]);

  if (!showNotification || !priceChangedMessage) return null;
  return (
    <CheckoutNotification
      color="code-red"
      title="Currency update"
      onClose={() => setShowNotification(false)}
    >
      <Stack space={4}>
        <Text>{priceChangedMessage}</Text>
      </Stack>
    </CheckoutNotification>
  );
};
